// @ts-nocheck
import { useNavigate } from "react-router-dom";
import { useEffect, forwardRef } from "react";
import styled from "styled-components";
import colors from "../../../styles/colors";
import PpvSpecificMatchList from "./PpvSpecificMatchList";

const Container = styled.div`
    width: 100%;
    margin-top: 40px;
    padding: 30px;
    background-color: ${colors.bgColorBlack2};
    border: 2px solid gold;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding-bottom: 20px;
    border-bottom: 2px solid rgba(255, 215, 0, 0.3);
`;

const Title = styled.h2`
    font-size: 28px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: gold;
    margin: 0;
    text-align: center;
`;

const PosterContainer = styled.div`
    width: 200px;
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid gold;
    border-radius: 5px;
    overflow: hidden;
    background-color: ${colors.bgColorBlack};
`;

const Poster = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
`;

const InfoContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const InfoSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const InfoLabel = styled.label`
    font-size: 16px;
    font-weight: 600;
    color: gold;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const InfoValue = styled.div`
    font-size: 16px;
    color: white;
    line-height: 1.6;
    padding: 10px;
    background-color: ${colors.bgColorBlack};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const IdContainer = styled.div`
    width: 100%;
    padding: 10px;
    background-color: ${colors.bgColorBlack};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
`;

const IdLabel = styled.span`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const IdValue = styled.span`
    font-size: 16px;
    color: white;
    font-weight: 600;
    margin-left: 10px;
`;

const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 2px solid rgba(255, 215, 0, 0.3);
    flex-wrap: wrap;
`;

const EditButton = styled.button`
    padding: 12px 24px;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    border: 2px solid gold;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
    
    &:hover {
        transform: scale(1.05);
        background-color: ${colors.bgColorRed};
    }
    
    &:active {
        transform: scale(0.98);
    }
`;

const DeleteButton = styled.button`
    padding: 12px 24px;
    background-color: #dc3545;
    color: white;
    border: 2px solid #dc3545;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
    
    &:hover:not(:disabled) {
        transform: scale(1.05);
        background-color: #c82333;
        border-color: #c82333;
    }
    
    &:active:not(:disabled) {
        transform: scale(0.98);
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const DeleteWarningMessage = styled.div`
    width: 100%;
    padding: 12px 20px;
    background-color: rgba(220, 53, 69, 0.1);
    border: 2px solid #dc3545;
    border-radius: 5px;
    color: #dc3545;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    margin: 15px 0;
`;

const NightsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    padding: 15px;
    background-color: ${colors.bgColorBlack};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const NightButton = styled.button`
    padding: 10px 20px;
    background-color: ${colors.bgColorBlack2};
    color: white;
    border: 1px solid white;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    min-width: 150px;
    
    &:hover {
        background-color: white;
        color: ${colors.bgColorBlack2};
    }
`;

const PpvSpecificDetail = forwardRef(function PpvSpecificDetail({ ppvSpecific, ppvGeneraleName, onEditClick, onDeleteClick, arenasList, onArenasLoad, onAddMatchClick, onEditMatchClick, onDeleteMatchClick }, ref) {
    const navigate = useNavigate();

    // Carica le arene se non sono disponibili
    useEffect(() => {
        if ((!arenasList || arenasList.length === 0) && onArenasLoad) {
            onArenasLoad();
        }
    }, [arenasList, onArenasLoad]);

    if (!ppvSpecific) {
        return null;
    }

    // Trova l'arena corrispondente
    const arena = arenasList && ppvSpecific.arena_id 
        ? arenasList.find(a => a.id === ppvSpecific.arena_id)
        : null;

    // Converte il valore della data in un oggetto Date
    const parseDate = (dateValue: any) => {
        if (!dateValue) return null;
        
        let date;
        
        // Se è un numero (timestamp)
        if (typeof dateValue === 'number') {
            // Se il numero è molto grande (> 1e12), è già in millisecondi
            // Altrimenti è in secondi e va moltiplicato per 1000
            if (dateValue > 1e12) {
                date = new Date(dateValue);
            } else {
                date = new Date(dateValue * 1000);
            }
        } 
        // Se è una stringa
        else if (typeof dateValue === 'string') {
            // Se contiene solo numeri, è un timestamp
            if (/^\d+$/.test(dateValue)) {
                const numValue = parseInt(dateValue);
                if (numValue > 1e12) {
                    date = new Date(numValue);
                } else {
                    date = new Date(numValue * 1000);
                }
            } 
            // Se è già in formato data (YYYY-MM-DD o simile)
            else if (dateValue.includes('-')) {
                // Prova a parsare come data ISO
                date = new Date(dateValue);
            } 
            else {
                date = new Date(dateValue);
            }
        } 
        else {
            date = new Date(dateValue);
        }
        
        // Verifica che la data sia valida
        if (isNaN(date.getTime())) {
            console.warn('Data non valida:', dateValue);
            return null;
        }
        
        return date;
    };

    // Formatta la data da timestamp
    const formatDate = (dateValue: any) => {
        const date = parseDate(dateValue);
        if (!date) return 'N/A';
        
        // Formatta come giorno mese anno
        return date.toLocaleDateString('it-IT', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        });
    };

    // Estrae solo l'anno dalla data
    const getYear = (dateValue: any) => {
        const date = parseDate(dateValue);
        if (!date) return '';
        return date.getFullYear();
    };

    const handleEditClick = () => {
        if (onEditClick) {
            onEditClick(ppvSpecific);
        } else {
            // Navigazione di default
            navigate(`/ppv/edit/${ppvSpecific.id}`);
        }
    };

    const handleDeleteClick = () => {
        if (onDeleteClick) {
            onDeleteClick(ppvSpecific);
        }
    };

    const handleNightClick = (nightUrl: any) => {
        if (nightUrl) {
            window.open(nightUrl, '_blank');
        }
    };

    return (
        <Container ref={ref} className="ppv-specific-detail-container">
            <Header className="ppv-specific-detail-header">
                <Title className="ppv-specific-detail-title">
                    {ppvGeneraleName || ''} {getYear(ppvSpecific.date) ? getYear(ppvSpecific.date) : ''}
                </Title>
                <PosterContainer className="ppv-specific-detail-poster-container">
                    <Poster 
                        src={process.env.REACT_APP_STORAGE_URL + ppvSpecific.img_path} 
                        alt={ppvSpecific.img_path + "_poster"} 
                        className="ppv-specific-detail-poster"
                    />
                </PosterContainer>
            </Header>

            <InfoContainer className="ppv-specific-detail-info-container">
                <InfoSection className="ppv-specific-detail-info-section">
                    <InfoLabel className="ppv-specific-detail-info-label">Data</InfoLabel>
                    <InfoValue className="ppv-specific-detail-info-value">
                        {formatDate(ppvSpecific.date)}
                    </InfoValue>
                </InfoSection>

                {arena && (
                    <InfoSection className="ppv-specific-detail-info-section">
                        <InfoLabel className="ppv-specific-detail-info-label">Arena</InfoLabel>
                        <InfoValue className="ppv-specific-detail-info-value">
                            {arena.name}{arena.city ? ` - ${arena.city}` : ''}
                        </InfoValue>
                    </InfoSection>
                )}

                {(ppvSpecific.night1 || ppvSpecific.night2 || ppvSpecific.night3) && (
                    <InfoSection className="ppv-specific-detail-info-section">
                        <InfoLabel className="ppv-specific-detail-info-label">Notti</InfoLabel>
                        <NightsContainer className="ppv-specific-detail-nights-container">
                            {ppvSpecific.night1 && (
                                <NightButton 
                                    type="button"
                                    onClick={() => handleNightClick(ppvSpecific.night1)}
                                    className="ppv-specific-detail-night-button"
                                >
                                    Notte 1
                                </NightButton>
                            )}
                            {ppvSpecific.night2 && (
                                <NightButton 
                                    type="button"
                                    onClick={() => handleNightClick(ppvSpecific.night2)}
                                    className="ppv-specific-detail-night-button"
                                >
                                    Notte 2
                                </NightButton>
                            )}
                            {ppvSpecific.night3 && (
                                <NightButton 
                                    type="button"
                                    onClick={() => handleNightClick(ppvSpecific.night3)}
                                    className="ppv-specific-detail-night-button"
                                >
                                    Notte 3
                                </NightButton>
                            )}
                        </NightsContainer>
                    </InfoSection>
                )}
            </InfoContainer>

            {ppvSpecific.fights && Array.isArray(ppvSpecific.fights) && ppvSpecific.fights.length > 0 && (
                <DeleteWarningMessage className="ppv-specific-detail-delete-warning-message">
                    Il ppv si può eliminare solamente se non ci sono match inseriti
                </DeleteWarningMessage>
            )}

            <ButtonContainer className="ppv-specific-detail-button-container">
                <EditButton 
                    onClick={handleEditClick}
                    className="ppv-specific-detail-edit-button"
                >
                    Modifica PPV
                </EditButton>
                <DeleteButton 
                    onClick={handleDeleteClick}
                    disabled={ppvSpecific.fights && Array.isArray(ppvSpecific.fights) && ppvSpecific.fights.length > 0}
                    className="ppv-specific-detail-delete-button"
                >
                    Elimina
                </DeleteButton>
            </ButtonContainer>

            {/* Lista dei match */}
            <PpvSpecificMatchList 
                fights={ppvSpecific.fights} 
                onAddMatchClick={onAddMatchClick}
                onEditMatchClick={onEditMatchClick}
                onDeleteMatchClick={onDeleteMatchClick}
            />
        </Container>
    );
});

export default PpvSpecificDetail;
